// client/src/pages/LandingPage.js
// 메인 랜딩 — v6 B안(몰입 히어로형) 확정 적용
// 로그인 세션 자동 리다이렉트·공개 API 실데이터·광고 대행(/contact)·공용 헤더/푸터는 기존 그대로.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import LandingHeroB from '../components/landing/LandingHeroB';
import RoleValueSection from '../components/landing/RoleValueSection';
import RecentProjectsSection from '../components/landing/RecentProjectsSection';
import AdAgencySection from '../components/landing/AdAgencySection';
import CTABandSection from '../components/landing/CTABandSection';
import Footer from '../components/landing/Footer';
import '../styles/pages/LandingB.css';
import '../styles/pages/PublicPages.css';

const API_URL = process.env.REACT_APP_API_URL;
const ME_TIMEOUT_MS = 3000;

/**
 * LandingPage - 비로그인 사용자를 위한 메인 랜딩페이지
 * 로그인 쿠키가 유효하면 역할 홈으로 replace 리다이렉트 (FEATURE_LANDING_LOGGED_IN_REDIRECT)
 */
function LandingPage() {
  const navigate = useNavigate();
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    let alive = true;
    const ac = new AbortController();
    const timer = setTimeout(() => ac.abort(), ME_TIMEOUT_MS);

    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/user/me`, {
          credentials: 'include',
          signal: ac.signal,
        });
        const data = await res.json().catch(() => ({}));
        if (!alive) return;

        if (res.ok && data.ok && data.role === 'influencer') {
          navigate('/influencer/mybiz', { replace: true });
          return;
        }
        if (res.ok && data.ok && data.role === 'marketer') {
          navigate('/marketer/mybiz', { replace: true });
          return;
        }
      } catch {
        // abort / 네트워크 — 비로그인과 동일, 랜딩 표시
      } finally {
        clearTimeout(timer);
      }
      if (alive) setBooting(false);
    })();

    return () => {
      alive = false;
      clearTimeout(timer);
      ac.abort();
    };
  }, [navigate]);

  if (booting) {
    return (
      <div
        className="lnd"
        style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div className="lnd-spinner" aria-label="로딩 중" />
      </div>
    );
  }

  return (
    <div className="lnd">
      <Header />
      <main>
        <LandingHeroB />
        <RoleValueSection />
        <RecentProjectsSection />
        <AdAgencySection />
        <CTABandSection />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
